import React, { memo } from "react";

const CheckoutFormField = ({ id, type, label, required, children, defaultValue, onChange}) => {
  return (
    <div className="checkout__main__form__field">
      <label htmlFor={id}>
        {label} {required && <span className="required">*</span>}
      </label>

      {!children && <input id={id} type={type} required={required} onChange={onChange} defaultValue={defaultValue}/>}

      {children && (
        <select id={id} required={required} defaultValue={defaultValue} onChange={onChange} >
          {children}
        </select>
      )}
    </div>
  );
};

export default memo(CheckoutFormField);
